/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Button, ButtonGroup, ModalActions, Stack, StyledModal } from 'sarsaparilla';

export default function AddressModal({
    onChangeAddressHandler,
    isAddressModalOpen,
    toggleAddressModal,
    originalAddress,
    suggestedAddress,
}) {
    const [address, setAddress] = useState(suggestedAddress);
    const isSuggestedChecked = isEqual(suggestedAddress, address);
    const isOriginalChecked = isEqual(originalAddress, address);

    return (
        <StyledModal
            size="md"
            onRequestClose={toggleAddressModal}
            shouldActionsStickInMobile
            isOpen={isAddressModalOpen}
            heading="Verify Your Address"
            overlayClassName="ia-address-modal"
        >
            <>
                <Stack>
                    <div className="rec-form-check-wrap">
                        <label htmlFor="suggested" className="rec-label-radio">
                            <input
                                className="rec-input-hide"
                                checked={isSuggestedChecked}
                                id="suggested"
                                type="radio"
                                name="suggested"
                                value="suggested"
                                onChange={() => setAddress(suggestedAddress)}
                            />
                            <span className="rec-input-radio" />
                            <strong>Use Suggested Address</strong>
                            <address>
                                <div>{suggestedAddress.address1}</div>
                                <div>{suggestedAddress.address2}</div>
                                <div>
                                    {suggestedAddress.city}, {suggestedAddress.state}{' '}
                                    {suggestedAddress.zip_code}
                                </div>
                            </address>
                        </label>
                    </div>
                    <div className="rec-form-check-wrap">
                        <label htmlFor="original" className="rec-label-radio">
                            <input
                                className="rec-input-hide"
                                checked={isOriginalChecked}
                                id="original"
                                type="radio"
                                name="suggested"
                                value="original"
                                onChange={() => setAddress(originalAddress)}
                            />
                            <span className="rec-input-radio" />
                            <strong>Use Original Address</strong>
                            <address>
                                <div>{originalAddress?.address1}</div>
                                <div>{originalAddress?.address2}</div>
                                <div>
                                    {originalAddress?.city}, {originalAddress?.state}{' '}
                                    {originalAddress?.zip_code}
                                </div>
                            </address>
                        </label>
                    </div>
                </Stack>
                <ModalActions>
                    <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                        <Button appearance="link" onClick={toggleAddressModal}>
                            Cancel
                        </Button>
                        <Button onClick={() => onChangeAddressHandler(address)}>
                            Use Selected Address
                        </Button>
                    </ButtonGroup>
                </ModalActions>
            </>
        </StyledModal>
    );
}

AddressModal.propTypes = {
    onChangeAddressHandler: PropTypes.func.isRequired,
    isAddressModalOpen: PropTypes.bool.isRequired,
    toggleAddressModal: PropTypes.func.isRequired,
    originalAddress: PropTypes.object.isRequired,
    suggestedAddress: PropTypes.object.isRequired,
};
